import   React                               ,
       { useEffect                           ,
         useState                            }  from 'react';
		 
import   classNames                             from 'classnames';

import   styles                                 from './SalesCampaignRow.module.scss';

import { SalesCampaign                       }  from '../../../dataTypes/salesCampaignManagment/types';

import   Toggle                                 from '../../widget/inputs/Toggle';
import   Icon                                   from '../../widget/images/Icon';


import { convertDateToString                 }  from '../../../dataTypes/timeManagment/utils';

import { getSalesCampaignTranscodingProgress }  from '../../../backendServices/mediaManagment/api_transcoder';

interface SalesCampaignRowProps {
  salesCampaign      : SalesCampaign;
  index              : number;
  onEdit             : (index: number) => void;
  onDelete           : (salesCampaign: SalesCampaign) => void;
  onVisibilityToggle : (id: number) => void;
  onTranscodeClick   : (salesCampaign: SalesCampaign) => void;
  onTranscoded       : (salesCampaign: SalesCampaign) => void;
  onDownloadClick    : (salesCampaign: SalesCampaign) => void;
}

export const SalesCampaignRow = ({ salesCampaign      ,
                                   index              ,
                                   onEdit             ,
                                   onDelete           ,
                                   onVisibilityToggle ,
								   onTranscodeClick   ,
								   onTranscoded       ,
								   onDownloadClick    }: SalesCampaignRowProps) => {

  const [ progress , setProgress ] = useState<number>(0);

  useEffect(() => {

    console.log ( "useEffect ",salesCampaign ) 

    if ( salesCampaign.state === 0 ) {

      const fetchProgress = async () => {

        const progressValue = await getSalesCampaignTranscodingProgress(salesCampaign.id);

        if ( progressValue.code === 1 )
         {
          setProgress ( Math.floor (progressValue.payload) );

          if ( progressValue.payload === 100 )
           {
            clearInterval(interval)
            onTranscoded (salesCampaign)
           }
         }
      };

      fetchProgress();

      const interval = setInterval(fetchProgress, 1000);
      return () => clearInterval(interval);
    }
  }, [salesCampaign]);

  return (
    <div className={classNames(styles.row)}>
      <div className={classNames(styles.column_1, styles.standard)}>
        {salesCampaign.id}
      </div>
      <div className={classNames(styles.column_2, styles.standard)} >
        {salesCampaign.name}
      </div>
      <div className={classNames(styles.column_3, styles.standard)}>
        {convertDateToString (salesCampaign.beginningDate, 'dd/MM/yyyy HH:mm')}
      </div>
      <div className={classNames(styles.column_4, styles.standard)}>
        {convertDateToString (salesCampaign.endingDate, 'dd/MM/yyyy HH:mm')}
      </div>
      <div className={classNames(styles.column_5, styles.standard)}>
		{
		 salesCampaign.state === -1 &&	
         <Icon name       = "filmStrip"
               onClick    = {() => onTranscodeClick(salesCampaign)}
		       color      = "var(--color-Icon-FG)"
               hoverColor = "var(--color-Icon-hover-FG)" />
	    }
		{
		 salesCampaign.state === 0 &&	
         <span>{progress}%</span>
	    }
		{
		 salesCampaign.state === 1 &&	
         <Icon name       = "floppyDisk"
               onClick    = {() => onDownloadClick(salesCampaign)}
		       color      = "var(--color-Icon-FG)"
               hoverColor = "var(--color-Icon-hover-FG)" />
	    }
      </div>
      <div className={classNames(styles.column_6, styles.standard)}>
        <Icon name       = "pen"
              onClick    = {() => onEdit(index)}
		      color      = "var(--color-Icon-FG)"
              hoverColor = "var(--color-Icon-hover-FG)" />
        &nbsp;
        <Icon name       = "trashCan"
              onClick    = {() => onDelete(salesCampaign)}
		      color      = "var(--color-Icon-FG)"
              hoverColor = "var(--color-Icon-hover-FG)" />
      </div>
      <div className={classNames(styles.column_7, styles.standard)}>
        <Toggle checked  = {salesCampaign.active}
                form     = "switch"
                onChange = {() => onVisibilityToggle(salesCampaign.id)}
        />
      </div>
    </div>
  );
};

export default SalesCampaignRow;
